import { render, staticRenderFns } from "./CreateRetentionPolicy.vue?vue&type=template&id=12c180c4&"
import script from "./CreateRetentionPolicy.vue?vue&type=script&lang=js&"
export * from "./CreateRetentionPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports